// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__24FXL","description":"PatientConsentPreview_description__2QEQU"};